import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import {
  RowSelectionContext,
  RowSelectionStore,
} from "@/components/data-table/context/RowSelectionContext";
import { List } from "@/components/list/List";
import { useStoresQuery } from "@/modules/store/hooks/useStoresQuery";
import { memo, useMemo } from "react";
import { ReadStore } from "@/types/store";
import { readStore } from "@/schemas/store";

export interface DefaultStoreProjectAssigneesCreatorStoresProps {
  store: RowSelectionStore;
}

const DefaultStoreProjectAssigneesCreatorStoresComponent = ({
  store,
}: DefaultStoreProjectAssigneesCreatorStoresProps) => {
  const contextValue = useMemo(() => ({ store }), [store]);

  const { query: storesQuery, options: storesOptions } = useStoresQuery({
    name: "default-store-project-assignees-stores",
  });

  return (
    <RowSelectionContext.Provider value={contextValue}>
      <DataTableQueryContextProvider value={{ query: storesQuery }}>
        <List<ReadStore>
          schema={readStore}
          name="defaultStoreProjectAssignees"
          query={storesQuery}
          options={storesOptions}
          tableFeatures={{
            enableRowSelection: true,
            enableSelectAll: true,
          }}
        >
          <div className="flex flex-row items-center gap-2">
            <List.Menubar className="grow">
              <List.Menubar.Columns />
              <List.Menubar.Reset />
            </List.Menubar>
          </div>
          <div className="flex flex-row grow gap-2 overflow-hidden">
            <List.Content className="overflow-x-auto flex-grow">
              <List.Status>
                <List.SelectedRowsStatus />
              </List.Status>
            </List.Content>
          </div>
        </List>
      </DataTableQueryContextProvider>
    </RowSelectionContext.Provider>
  );
};

export const DefaultStoreProjectAssigneesCreatorStores = memo(
  DefaultStoreProjectAssigneesCreatorStoresComponent,
);
